var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleauth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4887 14.293C26.4887 13.2027 26.4002 12.4071 26.2087 11.582H13.7578V16.503H21.0662C20.9189 17.726 20.1232 19.5677 18.355 20.8052L18.3302 20.97L22.267 24.0195L22.5397 24.0467C25.0446 21.7335 26.4887 18.33 26.4887 14.293Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7609 27.2588C17.3414 27.2588 20.3472 26.08 22.5428 24.0469L18.3581 20.8054C17.2382 21.5863 15.7353 22.1314 13.7609 22.1314C10.254 22.1314 7.2776 19.8183 6.21659 16.6211L6.06107 16.6343L1.9676 19.802L1.91406 19.9508C4.09479 24.2825 8.57417 27.2588 13.7609 27.2588Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21704 16.62C5.93708 15.795 5.77506 14.9109 5.77506 13.9974C5.77506 13.0839 5.93708 12.1999 6.20231 11.3748L6.19489 11.1991L2.05011 7.98047L1.9145 8.04497C1.01572 9.8425 0.5 11.8611 0.5 13.9974C0.5 16.1338 1.01572 18.1523 1.9145 19.9498L6.21704 16.62Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7609 5.86557C16.251 5.86557 17.9307 6.94112 18.8885 7.83994L22.6311 4.18596C20.3326 2.04958 17.3414 0.738281 13.7609 0.738281C8.57417 0.738281 4.09479 3.71446 1.91406 8.04613L6.20187 11.376C7.2776 8.17878 10.254 5.86557 13.7609 5.86557Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleauth);
export default __webpack_public_path__ + "static/media/googleauth.120704d39513e558bb1345bdb891ab22.svg";
export { ForwardRef as ReactComponent };